import i18n from "@/i18n";
import { AssetTypes } from "@/model/AssetTypes";
import { Resubmission } from "@/modules/resubmission/RSInterfaces";
import RSSubAssetMapper from "@/modules/resubmission/components/asset-details/sub-asset-mapper/RSSubAssetMapper";
import RSListDetailsComponent from "@/modules/resubmission/components/list-details/RSListDetailsComponent";
import classNames from "classnames";
import { Invoice } from "../../RAInterfaces";
// import "./InvoiceResubmissionView.scss";

interface InvoiceResubmissionViewProps {
  invoice: Invoice;
}
const InvoiceResubmissionView = (props: InvoiceResubmissionViewProps) => {
  const renderResubmissionObjectDetails = (resubmission: Resubmission) => {
    return (
      <RSSubAssetMapper resubmission={resubmission} asset={props.invoice} />
    );
  };

  const assetType = AssetTypes.Invoicing.Invoice;
  const typePermissions = [props.invoice.data.type];

  return (
    <div className={classNames("ap-activity-resubmission")}>
      <RSListDetailsComponent
        asset={props.invoice}
        assetType={assetType}
        assetDescription={`${i18n.t("ra:Invoice.label", "Rechnung")} ${
          props.invoice.data.invoice.invoiceId || ""
        }`}
        listIdentifier={`RA_RESUBMISSIONS_${props.invoice._id}`}
        renderResubmissionAssetDetails={renderResubmissionObjectDetails}
        typePermissions={typePermissions}
      />
    </div>
  );
};

export default InvoiceResubmissionView;
